import React, { FC, useMemo } from 'react';
import Select from 'components/Select/Select';
import { TSelectProps } from 'components/Select/Select.type';
import { useGetAvailableTimezonesQuery } from 'redux/apiSlices/organization.slice';
import { TTimeZone } from './TimeZone.type';

const TimeZone: FC<TTimeZone> = ({ onChange, ...props }) => {
  const { data: timezones = [], isLoading } = useGetAvailableTimezonesQuery();

  const handleChange = (e: TSelectProps) => {
    onChange?.(e);
  };
  // Convert timezone strings to options format
  const options = useMemo(
    () => timezones.map(tz => ({ label: tz, value: tz })),
    [timezones],
  );
  return (
    <div>
      <Select
        placeholder="Select timezone"
        options={options}
        onChange={handleChange}
        loading={isLoading}
        showSearch
        getPopupContainer={() => document.body}
        filterOption={(input, option) =>
          (option?.label as string)?.toLowerCase().includes(input.toLowerCase())
        }
        {...props}
      />
    </div>
  );
};

export default TimeZone;
